import React, { useState } from "react";
import { BsPlus, BsSubtract, BsTrash, BsLink } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { URL_S3 } from "../../../../config/BaseUrl";
import useTimeFormate from "../../../../hook/useTimeFormat";
function EventItem({
  item,
  setDuplicateEvent,
  eventType,
  per_page,
  page,
  user_id,
  search,
  targetModalId,
  removeModalId,
  mediaDownloadPubliclink
}) {
  const [isOpenMenu, setMenu] = useState(false);
  const { formateLocalTime } = useTimeFormate();
  const toggleMenu = () => {
    setMenu(!isOpenMenu);
  };

  const dispatch = useDispatch();

  const duplicateEvent = () => {
    const params = {
      per_page,
      page,
      user_id,
      search,
      event_type: eventType,
      uuid: item.uuid,
      event_id: item.id,
    };

    dispatch(setDuplicateEvent(params));
  };

  return (
    <div
      className={`live__event__card ${isOpenMenu ? "active" : ""}`}
      style={{
        backgroundImage: `url(${
          URL_S3 + "image/event_info/" + item.event_info_image
        })`,
        backgroundSize: "cover",
      }}
    >
      <div className="event-content">
        <p className="mb-1 text-white event-name">{item.event_name}</p>
        <p className="mb-0 text-white">@ {item.venue_name}</p>
      </div>
      <div className="event-time-and-action">
        <div className="event-time">
          <p className="mb-0">
            From: {formateLocalTime(item.event_start_date)}
          </p>
          {!item.life_time && (
            <p className="mb-0">To: {formateLocalTime(item.event_end_date)}</p>
          )}
        </div>
        <div className="event-action">
          <div className={`menu ${isOpenMenu ? "active" : ""}`}>
            <div className="toggle" onClick={toggleMenu}>
              <BsPlus />
            </div>
            <li style={{ "--i": 1 }}>
              <Link
                to={`/show/event/${item.id}`}
                className="event-action-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Settings"
              >
                <i className="fadeIn animated lni lni-eye"></i>
              </Link>
            </li>
            <li style={{ "--i": 2 }}>
              <Link
                to={{ pathname: `/event-photos/${item.id}`, state: item }}
                className="event-action-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Gallery"
              >
                <i className="fadeIn animated bx bx-image-alt"></i>
              </Link>
            </li>
            <li style={{ "--i": 3 }}>
              <Link
                to={`/event-analytic/${item.id}`}
                className="event-action-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Analytics"
              >
                <i className="fadeIn animated bx bx-bar-chart"></i>
              </Link>
            </li>
            <li style={{ "--i": 4 }}>
              <a
                href="#"
                onClick={duplicateEvent}
                className="event-action-btn"
                data-toggle="modal"
                data-target={`#${targetModalId}`}
                title="Duplicate"
              >
                <BsSubtract />
              </a>
            </li>
            <li style={{ "--i": 5 }}>
              <a 
              href="#"
              onClick={duplicateEvent}
              className="event-action-btn"
              data-toggle="modal"
              data-target={`#${mediaDownloadPubliclink}`}
              title="Media Link"
              >
                <BsLink />
              </a>
            </li>
            <li style={{ "--i": 6 }}>
              <a
                href="#"
                onClick={duplicateEvent}
                className="event-action-btn"
                data-toggle="modal"
                data-target={`#${removeModalId}`}
                title="Remove"
              >
                <BsTrash />
              </a>
            </li>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventItem;
